<template>
  <div class="container-fluid">

    <div class="container-fluid bg-base-green trees-bg">
      <div class="row pt-5 pb-5">
        <div class="col-12">
          <h1 class="title text-center">{{$t('mapa_page_h1')}}</h1>
          <div class="intro">{{$t('mapa_page_intro')}}</div>
        </div>      
      </div>
    </div>

    <div class="container-fluid">
      <div class="container-float">
        <MapaPlanes :selected="selectedFeature" :datapmf="selectedFeature.pmf" :show-layer="show_layer" :departamentos="departamentos" :departamentos_distritos="departamentos_distritos" :circle-show="circleShow"></MapaPlanes>
      </div>
      <div class="container-fluid container-map">

        <div class="row">
          <div class="col-1"></div>
          <div class="col-12 col-md-3 pt-3">

            <div class="btn-group btn-group-toggle btn-group-layer">
              <label class="btn btn-secondary" :class="{'active': show_layer == 'show_departamentos'}">
                <input type="radio" name="options" value="show_departamentos" id="option1"  v-model="show_layer" autocomplete="off" checked>{{$t('mapa_page_departamento')}} 
              </label>
              <label class="btn btn-secondary" :class="{'active': show_layer == 'show_distritos'}">
              <input type="radio" name="options"  value="show_distritos" id="option2"  v-model="show_layer" autocomplete="off">
              {{$t('mapa_page_distrito')}} 
              </label>
            </div>

            <div class="filters-map mb-3">
              <b-form-checkbox
              v-model="circleShow"
            >{{$t('mapa_page_mostrar')}}            
            </b-form-checkbox></div>

            <div class="filters-map">
              <b-tabs>                
                <b-tab :title="$t('mapa_modality')">
                  <b-form-group>
                    <template #label>
                      <b-form-checkbox
                        checked="true"
                        class="check"
                        aria-describedby="modalidad"
                        aria-controls="modalidad"
                        @change="toggleModalidad"                      
                      >
                        {{modalidad_selected.length > 0 ? $t('mapa_select_todos') : $t('mapa_select_all')}}
    
                      </b-form-checkbox>
                    </template>
                    <template v-slot="{ ariaDescribedby }">
                      <b-form-checkbox-group class="check check-modalidades" v-model="modalidad_selected" :options="modalidad" :aria-describedby="ariaDescribedby" name="modalidad"></b-form-checkbox-group>
                    </template>
                  </b-form-group>
                </b-tab>
              </b-tabs>        
            </div>

            <div class="filters-map mt-3">
              <b-tabs v-model="field_anio">
                <b-tab value="anio_sup" :title="$t('mapa_select_anio_sup')">
                  <b-form-group>
                    <template #label>
                      <b-form-checkbox
                        checked="true"
                        class="check"
                        aria-describedby="anio"
                        aria-controls="anio"
                        @change="toggleAll"
                      >
                        {{ anio_sup.length > 0 ? $t('mapa_select') : $t('mapa_select')}}
                      </b-form-checkbox>
                    </template>  
                    <template v-slot="{ ariaDescribedby }">
                      <b-form-checkbox-group class="check check-anio" v-model="anio_sup" :options="yearInforme" :aria-describedby="ariaDescribedby" name="anio"></b-form-checkbox-group>
                    </template>
                  </b-form-group>      
                  
                </b-tab>
                <b-tab value="anio_aprob" :title="$t('mapa_select_anio_aprob')">  
                  <b-form-group>
                    <template #label>
                      <b-form-checkbox
                        checked="true"
                        class="check"
                        aria-describedby="aprobacion"
                        aria-controls="aprobacion"
                        @change="toggleAprob"
                      >
                        {{anio_aprobado.length > 0 ? $t("mapa_select") : $t("mapa_select")}}

                      </b-form-checkbox>
                    </template>
                    <template v-slot="{ ariaDescribedby }">
                      <b-form-checkbox-group class="check" v-model="anio_aprobado" :options="yearAprobacion" :aria-describedby="ariaDescribedby" name="aprobacion"></b-form-checkbox-group>                      
                    </template>
                  </b-form-group>
                  
                </b-tab>
              </b-tabs>              
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import * as d3 from 'd3'
  import { filter, groupBy, map, uniq, sumBy, orderBy } from 'lodash'
  import { feature } from 'topojson'
  import MapaPlanes from '../components/MapaPlanes.vue'

  export default {
    name: 'MapaPage',
    components: { MapaPlanes },
    props: {
      dataset: Array
    },
    data() {
      return {
        field_anio: 0,
        modalidad_selected: ['concesión_forestal_maderable'],
        anio_sup: ['2015'],
        anio_aprobado: ['2015'],
        show_layer: 'show_departamentos',
        selectedFeature: {"name":null, "count": 0, "pmf": []},
        circleShow: false
      }
    },
    mounted() {
      this.toggleModalidad(true)
      this.toggleAll(true)
      this.toggleAprob(true)
    },
    methods: {
      departamentoSlug(d) {
        return d.replace(" ","_").toLowerCase().replace(" ","_")
      },
      toggleAll(checked) {
        this.anio_sup = checked ? this.yearInforme.slice() : []
      },
      toggleAnio(checked) {
        this.yearInforme = checked ? this.anio_sup.slice() : []
      },
      toggleModalidad(checked) {
        this.modalidad_selected = checked ? map(this.modalidad, 'value').slice() : []
      },
      toggleAprob(checked) {
        this.anio_aprobado = checked ? this.yearAprobacion.slice() : []
      },
      markers(features, items) {
        let radius = d3.scaleLinear()
          .domain([0, 100])
          .range([3, 30])

      let colorScale = d3.scaleThreshold()
        .domain([1, 10, 20, 50, 100, 200])
        .range(['#ffffb2','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#b10026']);

        return filter(map(features.features, (dis, n) => {
          let data = filter(items, item => {
            if(item.distrito == dis.properties.DISTRITO && item.provincia == dis.properties.PROVINCIA && item.departamento == dis.properties.DEPARTAMEN) {
              return item
            }
          })

          let latitud = uniq(map(data, 'latitud')).join('')
          let longitud = uniq(map(data, 'longitud')).join('')

          return {
            id: `distrito_${n}`,
            distrito: `${dis.properties.DISTRITO}`,
            provincia: `${dis.properties.PROVINCIA}`,
            departamento: `${dis.properties.DEPARTAMEN}`,
            radius: radius((sumBy(data, 'individuos_inexistentes') / sumBy(data, 'mues_supervisado_pmf')) * 100),
            latitud: latitud,
            longitud: longitud,
            pmf: data.length,
            supervisado: sumBy(data, 'mues_supervisado_pmf'),
            inexistentes: sumBy(data, 'individuos_inexistentes'),
            percent_inexistentes: ((sumBy(data, 'individuos_inexistentes') / sumBy(data, 'mues_supervisado_pmf')) * 100),
            center: data.length > 0 ? [latitud, longitud] : false,
            color: '#333333',
            planes: data,
            style: {
              weight: 2,
              color: "#ECEFF1",
              fillColor: colorScale(items.length),
              fillOpacity: 0.7
            }
          }
        }), f => {
          if(f.latitud) {
            return f
          }
        })
      },
      onEachFeatureFunction(item) {
        
        let d = filter(this.data_filtrada, ['departamento', item.properties.NOMBDEP])

        let colorScale = d3.scaleThreshold()
            .domain([0, 5, 10, 20, 50, 100, 200, 600])
            .range(['#ffffff','#ffffb2','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#b10026']);

        return colorScale(d.length)
      },
      peru_map() {
        return require(`../data/mapas/peru.json`)
      },
    },    
    computed:{    
      modalidad() {
        let subset=map(this.dataset, 'modalidad').sort()

        return map(uniq(subset), m => {
          return {
            text: this.$t(m),
            value: m
          }
        })
      },
      yearInforme() {
        let subset = map(this.dataset, "anio_informe").sort()
        return uniq(subset)          
      },
      yearAprobacion() {
        let subset = map(this.dataset, "anio_aprob").sort()
        return uniq(subset)          
      },
      departamentos() {
        let colorScale = d3.scaleThreshold()
          .domain([0, 5, 10, 20, 50, 100, 200, 600])
          .range(['#ffffff','#ffffb2','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#b10026'])
        
        let data_filtered = this.data_filtrada

        return {
          id: `mapaPeru`,
          content: this.peru_map(),
          options: {
            style: (f) => {
              let d = filter(data_filtered, ['departamento', f.properties.NOMBDEP])
              return {
                weight: 2,
                color: "#ECEFF1",
                fillColor: colorScale(d.length),
                fillOpacity: d.length > 0 ? 0.7 : 0
              }
            },
            onEachFeature: (feature, layer) => {
              let d = orderBy(filter(data_filtered, ['departamento', feature.properties.NOMBDEP]), ['mues_supervisado_pmf'], ['desc'])
              if(d.length > 0) {
                layer.on('click', () => {
                  this.selectedFeature['name'] = feature.properties.NOMBDEP
                  this.selectedFeature['count'] = d.length
                  this.selectedFeature['pmf'] = d
                })
              }
            }
          }
        }

      },
      data_filtrada() {
        let data_filtrada = filter(this.dataset, item => {
          if(this.modalidad_selected.includes(item.modalidad) && this.anio_sup.includes(item.anio_informe) && this.field_anio == 0) {
            return item
          }
          else if(this.modalidad_selected.includes(item.modalidad) && this.anio_aprobado.includes(item.anio_aprob) && this.field_anio == 1) {
            return item
          }
        })

        return data_filtrada
      },
      departamentos_distritos() {


        return map(groupBy(this.data_filtrada, "departamento"),(items, d) => {
          let json = require(`../data/mapas/${this.departamentoSlug(d)}.json`)
          let features = feature(json, json.objects[this.departamentoSlug(d)])

          let colorScale = d3.scaleThreshold()
            .domain([0, 5, 20, 30, 40, 50, 60, 70])
            .range(['#ffffff','#ffffb2','#fed976','#feb24c','#fd8d3c','#fc4e2a','#e31a1c','#b10026']);

          return {
            id: this.departamentoSlug(d),
            distritos: this.markers(features, items),
            content: features,
            options: {
              style: (f) => {
                

                let dis = filter(items, i => {
                  if(f.properties.DISTRITO == i.distrito && f.properties.PROVINCIA == i.provincia && f.properties.DEPARTAMEN == d) {
                    return i
                  }
                })

                return {
                  weight: 1,
                  color: dis.length > 0 ? "#5f5f5f": "#fff",
                  fillColor: colorScale(dis.length),
                  fillOpacity: dis.length > 0 ? 0.7 : 0
                }
              },
              onEachFeature: (feature, layer) => {
                let d = orderBy(filter(items, ['distrito', feature.properties.DISTRITO]), ['mues_supervisado_pmf'], ['desc'])
                if(d.length > 0) {
                  layer.on('click', () => {
                    this.selectedFeature['name'] = `${feature.properties.DISTRITO}`
                    this.selectedFeature['prov'] = `${feature.properties.PROVINCIA}`
                    this.selectedFeature['dep'] = `${feature.properties.DEPARTAMEN}`
                    this.selectedFeature['count'] = d.length
                    this.selectedFeature['pmf'] = d
                  })
                }
              }
            }
          }
        })
      }
    }
  }
</script>